module.exports = __webpack_public_path__ + "static/media/icon-close-light.a1810fd0.svg";